import {TimelineSprite} from "../../core/animation/TimelineSprite";
import {Game} from "../Game";
import {gsap} from "gsap";
import {GameFeatureMode} from "../enums/Enum";

export class FeatureLogoView extends PIXI.Container {
    private _xWaysInActive: PIXI.Sprite;
    private _xWaysBright: PIXI.Sprite;
    private _xWaysActive: PIXI.Sprite;
    private _xSplitInActive: PIXI.Sprite;
    private _xSplitBright: PIXI.Sprite;
    private _xSplitActive: PIXI.Sprite;
    private _xNudgeInActive: PIXI.Sprite;
    private _xNudgeBright: PIXI.Sprite;
    private _xNudgeActive: PIXI.Sprite;
    private _xGodInActive: PIXI.Sprite;
    private _xGodActive: PIXI.Sprite;

    private _xMentalInActive: PIXI.Sprite;
    private _xMentalActive: PIXI.Sprite;

    private _xHoleInActive: PIXI.Sprite;
    private _xHoleActive: PIXI.Sprite;

    private _xWaysBlast: TimelineSprite;
    private _xSplitBlast: TimelineSprite;
    private _xNudgeBlast: TimelineSprite;
    private _xMentalBlast: TimelineSprite;
    private _xHoleBlast: TimelineSprite;
    private _xGodBlast: TimelineSprite;

    private _isXWaysActive: boolean = false;
    private _isXSplitActive: boolean = false;
    private _isXNudgeActive: boolean = false;
    private _isXMentalActive: boolean = false;
    private _isXHoleActive: boolean = false;
    private _isXGodActive: boolean = false;
    private _duration: number = 0.1;

    constructor() {
        super();
        this.init();
        this.name = "FeatureLogoContainer";
    }

    public resetAll(): void {
        this.hideXSplitActiveIndicator();
        this.hideXNudgeActiveIndicator();
        this.hideXWaysActiveIndicator();
        this.restXGodIndicator()
        this.restXHoleIndicator();
        this.restXMentalIndicator();
    }

    public playXWaysActive(): void {
        if (this._isXWaysActive) {
            this._xWaysBright.visible = true;
            this._xWaysBright.alpha = 0;
            gsap.to(this._xWaysBright, {alpha: 1, _duration: this._duration});
            gsap.to(this._xWaysBright, {
                alpha: 0, _duration: this._duration, delay: this._duration, onComplete: () => {
                    this._xWaysBright.visible = false
                }
            });
        } else {
            this._xWaysActive.visible = true;
            this._xWaysActive.alpha = 0;
            gsap.to(this._xWaysActive, {
                _duration: this._duration,
                alpha: 1
            });

            this._xWaysBlast.getAnimationAutoShowHide(true, true);

            this._isXWaysActive = true;
        }
    }

    public playXSplitActive(): void {
        if (this._isXSplitActive) {
            this._xSplitBright.visible = true;
            this._xSplitBright.alpha = 0;
            gsap.to(this._xSplitBright, {alpha: 1, _duration: this._duration});
            gsap.to(this._xSplitBright, {
                alpha: 0, _duration: this._duration, delay: this._duration, onComplete: () => {
                    this._xSplitBright.visible = false
                }
            });
        } else {
            this._xSplitActive.visible = true;
            this._xSplitActive.alpha = 0;
            gsap.to(this._xSplitActive, {
                _duration: this._duration,
                alpha: 1
            });

            this._xSplitBlast.getAnimationAutoShowHide(true, true);

            this._isXSplitActive = true;
        }
    }

    public playXNudgeActive(): void {
        if (this._isXNudgeActive) {
            this._xNudgeBright.visible = true;
            this._xNudgeBright.alpha = 0;
            gsap.to(this._xNudgeBright, {alpha: 1, _duration: this._duration});
            gsap.to(this._xNudgeBright, {
                alpha: 0, _duration: this._duration, delay: this._duration, onComplete: () => {
                    this._xNudgeBright.visible = false
                }
            });
        } else {
            this._xNudgeActive.visible = true;
            this._xNudgeActive.alpha = 1;
            gsap.to(this._xNudgeActive, {
                _duration: this._duration,
                alpha: 1
            });

            this._xNudgeBlast.getAnimationAutoShowHide(true, true);

            this._isXNudgeActive = true;
        }
    }

    public playXMentalActive(duration?: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        if (!this._isXMentalActive) {
            this._xMentalActive.visible = true;
            this._xMentalActive.alpha = 0;
            tl.add([
                gsap.to(this._xMentalActive, {
                    _duration: duration || this._duration,
                    alpha: 1
                }),
                this._xMentalBlast.getAnimationAutoShowHide(true, true)
            ]);
            this._isXMentalActive = true;
        }
        return tl;
    }

    public playXHoleActive(duration?: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        if (!this._isXHoleActive) {
            this._xHoleActive.visible = true;
            this._xHoleActive.alpha = 0;
            tl.add([
                gsap.to(this._xHoleActive, {
                    _duration: duration || this._duration,
                    alpha: 1
                }),
                this._xHoleBlast.getAnimationAutoShowHide(true, true)
            ]);
            this._isXHoleActive = true;
        }
        return tl;
    }

    public restXHoleIndicator(duration?: number): void {
        this.hideActiveIndicator(this._xHoleActive, duration).eventCallback("onComplete", () => {
            this._xHoleActive.visible = false;
        });
        this._xHoleBlast.hide();
        this._isXHoleActive = false;
    }

    public restXMentalIndicator(duration?: number): void {
        let alpha: number = 0;
        // #365
        if (Game.model.data.nextMode === GameFeatureMode.RESPIN) {
            alpha = 0.5;

            if (Game.model.isRestore) {
                this._xMentalActive.visible = true;
            }
        }

        this.hideActiveIndicator(this._xMentalActive, duration, alpha).eventCallback("onComplete", () => {
            if (alpha === 0) {
                this._xMentalActive.visible = false;
            }
        });
        this._xMentalBlast.hide();
        this._isXMentalActive = false;
    }

    public hideActiveIndicator(obj: PIXI.Sprite, duration?: number, alpha?: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.to(obj, {
            _duration: duration || this._duration,
            alpha: alpha || 0,
            onComplete: () => {
                this._xGodActive.visible = false
            }
        });
        return tl;
    }


    public restXGodIndicator(duration?: number): void {
        this.hideActiveIndicator(this._xGodActive, duration);
        this._xGodActive.visible = false;
        this._xGodBlast.hide();
        this._isXGodActive = false;
    }

    public playXGodBlink(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        this._xGodActive.visible = true;
        this._xGodActive.alpha = 0;
        tl.to(this._xGodActive, {
            duration: duration / 4,
            alpha: 1
        });
        tl.to(this._xGodActive, {
            duration: duration / 4,
            alpha: 0
        });
        tl.to(this._xGodActive, {
            duration: duration / 4,
            alpha: 1
        });
        tl.to(this._xGodActive, {
            duration: duration / 4,
            alpha: 0
        });
        return tl;
    }

    public playXGodActive(duration?: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        if (!this._isXGodActive) {
            this._xGodActive.visible = true;
            this._xGodActive.alpha = 0;
            tl.add([
                gsap.to(this._xGodActive, {
                    _duration: duration || this._duration,
                    alpha: 1
                }),
                this._xGodBlast.getAnimationAutoShowHide(true, true)
            ]);
            this._isXGodActive = true;
        }
        return tl;
    }

    public hideXWaysActiveIndicator(duration?: number) {
        this.hideActiveIndicator(this._xWaysActive, duration);
        this._xWaysBright.visible = false;
        this._xWaysBlast.hide();
        this._isXWaysActive = false;

    }

    public hideXSplitActiveIndicator(): void {
        gsap.to(this._xSplitActive, {
            _duration: this._duration,
            alpha: 0,
            onComplete: () => {
                this._xSplitActive.visible = false
            }
        });
        this._xSplitBright.visible = false;
        this._xSplitBlast.hide();
        this._isXSplitActive = false;
    }

    public hideXNudgeActiveIndicator(duration?: number): void {
        this.hideActiveIndicator(this._xNudgeActive, duration)
        this._xNudgeBright.visible = false;
        this._xNudgeBlast.hide();
        this._isXNudgeActive = false;
    }

    private createSprite(name: string, position: number[], isVisible?: boolean): PIXI.Sprite {
        const logo: PIXI.Sprite = new PIXI.Sprite(Game.assetLoader.getTextures(name)[0]);
        logo.anchor.set(0.5);
        logo.scale.set(0.6);
        logo.position.set(position[0], position[1]);
        logo.visible = isVisible ? isVisible : false;
        return logo;
    }

    private createBlastTimelineSprite(): TimelineSprite {
        const item: TimelineSprite = new TimelineSprite(Game.assetLoader.getTextures("multiplier_blast/multiplier_blast_"));
        item.hide();
        item.anchor.set(0.5);
        item.scale.set(1.35);
        item.blendMode = PIXI.BLEND_MODES.ADD;

        return item;
    }

    private init() {
        let pos: number[] = [475, 133];
        this._xWaysInActive = this.createSprite("xmachine_text/Xways", pos, true);
        this._xWaysInActive.name = "X_WAYS_INACTIVE";
        this._xWaysBright = this.createSprite("xmachine_text/Xways_shine_blink", pos);
        this._xWaysBright.name = "X_WAYS_BRIGHT";
        this._xWaysActive = this.createSprite("xmachine_text/Xways_active", pos);
        this._xWaysActive.name = "X_WAYS_ACTIVE";

        pos = [471, 189];
        this._xSplitInActive = this.createSprite("xmachine_text/Xsplit", pos, true);
        this._xSplitInActive.name = "X_SPLIT_INACTIVE";
        this._xSplitBright = this.createSprite("xmachine_text/Xsplit_shine_blink", pos);
        this._xSplitBright.name = "X_SPLIT_BRIGHT";
        this._xSplitActive = this.createSprite("xmachine_text/Xsplit_active", pos);
        this._xSplitActive.name = "X_SPLIT_ACTIVE";

        pos = [539, 189];
        this._xNudgeInActive = this.createSprite("xmachine_text/Xnudge", pos, true);
        this._xNudgeInActive.name = "X_NUDGE_INACTIVE";
        this._xNudgeBright = this.createSprite("xmachine_text/Xnudge_shine_blink", pos);
        this._xNudgeBright.name = "X_NUDGE_BRIGHT";
        this._xNudgeActive = this.createSprite("xmachine_text/Xnudge_active", pos);
        this._xNudgeActive.name = "X_NUDGE_ACTIVE";

        //XMental
        pos = [220, 133];
        this._xMentalInActive = this.createSprite("xmachine_text/xmental_logo", pos, true);
        this._xMentalInActive.name = "X_Mental_INACTIVE";
        this._xMentalInActive.scale.set(0.4);
        this._xMentalActive = this.createSprite("xmachine_text/xmental_shine_00000_00000", pos);
        this._xMentalActive.name = "X_Mental_ACTIVE";
        this._xMentalActive.scale.set(0.4);

        //Xhole
        pos = [505, 162];
        this._xHoleInActive = this.createSprite("xmachine_text/xhole", pos, true);
        this._xHoleInActive.name = "X_Hole_INACTIVE";
        this._xHoleActive = this.createSprite("xmachine_text/xhole_shine", pos);
        this._xHoleActive.name = "X_Hole_ACTIVE";

        pos = [538, 132];
        this._xGodInActive = this.createSprite("xmachine_text/xgod_small", pos, true);
        this._xGodInActive.name = "X_GOD_INACTIVE";
        this._xGodActive = this.createSprite("xmachine_text/xgod_shine_blink", pos);
        this._xGodActive.name = "X_GOD_ACTIVE";

        this._xWaysBlast = this.createBlastTimelineSprite();
        this._xWaysBlast.position = this._xWaysActive.position;

        this._xSplitBlast = this.createBlastTimelineSprite();
        this._xSplitBlast.position = this._xSplitActive.position;

        this._xNudgeBlast = this.createBlastTimelineSprite();
        this._xNudgeBlast.position = this._xNudgeActive.position;

        this._xMentalBlast = this.createBlastTimelineSprite();
        this._xMentalBlast.position = this._xMentalActive.position;
        this._xMentalBlast.name = "XMentalBlast";

        this._xGodBlast = this.createBlastTimelineSprite();
        this._xGodBlast.position = this._xGodActive.position;

        this._xHoleBlast = this.createBlastTimelineSprite();
        this._xHoleBlast.position = this._xHoleActive.position;
        this._xHoleBlast.name = "XHoleBlast";

        this.addChild(
            this._xWaysInActive, this._xWaysBright, this._xWaysActive,
            this._xSplitInActive, this._xSplitBright, this._xSplitActive,
            this._xNudgeInActive, this._xNudgeBright, this._xNudgeActive,
            this._xMentalInActive,this._xMentalActive,
            this._xGodInActive, this._xGodActive,
            this._xHoleInActive, this._xHoleActive,
            this._xWaysBlast, this._xSplitBlast, this._xNudgeBlast, this._xMentalBlast, this._xGodBlast, this._xHoleBlast);
    }
}